// extracted by mini-css-extract-plugin
export default {"add-media-button":"add-media-button__moseI","inline":"inline__dPVhb","label-text":"label-text__h0cYk"};